import LatestDownloadBar from "~/components/LatestDownloadBar/LatestDownloadBar";
import WhatsNew from "~/components/WhatsNew/WhatsNew";
import * as React from 'react';
export default {
  LatestDownloadBar,
  WhatsNew,
  React
};